// Marketing content — testimonials, blog, partners, tracking, etc.

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Dr. Sofia Hernández",
    role: "Aesthetic Physician · Madrid",
    quote:
      "Discount Fillers has become our single source for Korean injectables. Authentic stock, fast EU shipping, and pricing that actually moves our margin.",
    avatar: "https://images.pexels.com/photos/32428850/pexels-photo-32428850.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=400",
  },
  {
    id: 2,
    name: "Dr. Marcus Reid",
    role: "Dermatologist · London",
    quote:
      "Their inventory depth on HA fillers and skin boosters is unmatched. The tracking system gives us peace of mind from order to clinic door.",
    avatar: "https://images.pexels.com/photos/29648642/pexels-photo-29648642.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=400",
  },
  {
    id: 3,
    name: "Clinic Operations · Beauté Lab",
    role: "Multi-site cosmetic group · Paris",
    quote:
      "We onboarded across 6 clinics. Procurement that used to take days now takes minutes. Lot numbers, expiry dates and origin certificates always provided.",
    avatar: "https://images.pexels.com/photos/3938022/pexels-photo-3938022.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=400",
  },
];

export const PARTNERS = [
  "Hugel",
  "Medytox",
  "Daewoong",
  "LG Chem",
  "Caregen",
  "Pharma Research",
  "Huons",
  "Galderma",
  "Allergan",
  "Merz",
];

export const HOW_IT_WORKS = [
  {
    step: "01",
    title: "Verify your clinic",
    body: "Submit your license. We onboard only credentialed medical professionals — usually within 24h.",
  },
  {
    step: "02",
    title: "Browse wholesale catalog",
    body: "Access live B2B pricing across 9 categories. Bulk tiers unlock automatically at checkout.",
  },
  {
    step: "03",
    title: "Place your order",
    body: "Cart, request quote, or use bulk PO. Pay by wire, card or crypto. Lot numbers issued instantly.",
  },
  {
    step: "04",
    title: "Track & receive",
    body: "Cold-chain shipping with full traceability. Every package tracked end-to-end through our portal.",
  },
];

export const TRACKING_STEPS = [
  { code: "ORD", label: "Order placed", time: "Day 0" },
  { code: "VFY", label: "Verified & invoiced", time: "Day 0" },
  { code: "PKD", label: "Cold-chain packed", time: "Day 1" },
  { code: "SHP", label: "In transit", time: "Day 2–5" },
  { code: "DLV", label: "Delivered", time: "Day 5–7" },
];

const BLOG_IMG = [
  "https://images.pexels.com/photos/16571739/pexels-photo-16571739.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/16571735/pexels-photo-16571735.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/11040188/pexels-photo-11040188.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/5922101/pexels-photo-5922101.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/7722842/pexels-photo-7722842.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export const BLOG_POSTS = [
  { id: 1, category: "Education", title: "Understanding HA Filler Crosslinking: G-Prime Explained", excerpt: "What G-prime, cohesivity and elasticity actually mean for clinical outcomes — and how to choose the right gel for each anatomical region." },
  { id: 2, category: "Industry", title: "Korean vs European Toxins: A 2026 Buyer's Guide", excerpt: "Comparing onset, diffusion and cost-per-unit across Botulax, Nabota, Dysport and Botox Cosmetic in real clinical settings." },
  { id: 3, category: "Treatments", title: "Exosome Therapy: From Hype to Standard of Care", excerpt: "How exosome boosters are reshaping post-laser recovery and hair restoration protocols across European clinics." },
  { id: 4, category: "Business", title: "Margin Math: Pricing Injectables in Your Clinic", excerpt: "Wholesale cost is only the start. Build a defensible price ladder using product positioning and treatment bundling." },
  { id: 5, category: "Safety", title: "Cold Chain 101: Why It Matters for Biostimulators", excerpt: "Temperature deviations silently degrade PLLA and PCL. Here's how we keep yours intact from Seoul to your fridge." },
  { id: 6, category: "Education", title: "Skin Booster Protocols: Rejuran vs Profhilo vs Hyaron", excerpt: "Clinical indications, injection depth, and session cadence — a side-by-side technical comparison." },
  { id: 7, category: "Treatments", title: "Lipolysis in Body Contouring: Patient Selection", excerpt: "Identifying ideal candidates and managing expectations to drive 5-star outcomes and word-of-mouth growth." },
  { id: 8, category: "Industry", title: "What Changed in EU CE Marking for Injectables", excerpt: "MDR Class III requirements, what suppliers must disclose, and how to vet your distributor in 2026." },
  { id: 9, category: "Practice", title: "Building a Loyal Cosmetic Practice with Bundling", excerpt: "How leading clinics use HA + toxin + booster combos to lift LTV by 40% in the first year." },
  { id: 10, category: "Technology", title: "Cannulas vs Needles: Choosing for Tear Trough", excerpt: "Reduced bruising, less downtime, and the safety profile clinicians weigh per anatomical zone." },
].map((p, i) => ({ ...p, image: BLOG_IMG[i % BLOG_IMG.length], readTime: `${4 + (i % 5)} min read` }));

export const HERO_SLIDES = [
  {
    eyebrow: "Wholesale · B2B · MOQ 5 units",
    headlineBold: "Wholesale aesthetic",
    headlineThin: "supplies, direct to clinics.",
    body: "Authentic Korean & global injectables shipped cold-chain. Volume discounts from 5 units, up to 8% off at 50+.",
    cta: "Explore catalog",
    image: "https://images.pexels.com/photos/11040188/pexels-photo-11040188.png?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  },
  {
    eyebrow: "HA Fillers · 2026 Catalog",
    headlineBold: "HA fillers,",
    headlineThin: "from $14.50 / syringe.",
    body: "90+ HA filler SKUs in stock. Restylane, Juvederm alternatives, Neuramis, Yvoire, VOM. Bulk tiers from 5 units.",
    cta: "Shop HA fillers",
    image: "https://images.pexels.com/photos/5922101/pexels-photo-5922101.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  },
  {
    eyebrow: "Trusted by 1,200+ clinics",
    headlineBold: "Premium toxins.",
    headlineThin: "Verified lot numbers.",
    body: "Botulax, Nabota, Meditoxin, Xeomin, Dysport, Innotox. Stocked, sealed, batch-traceable.",
    cta: "Shop neurotoxins",
    image: "https://images.unsplash.com/photo-1746708810803-722593e53772?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxzeXJpbmdlJTIwZmFjZSUyMGluamVjdGlvbiUyMGFlc3RoZXRpYyUyMGJvdG94fGVufDB8fHx8MTc4MjIwMTkzMHww&ixlib=rb-4.1.0&q=85",
  },
];

export const BANNERS = [
  {
    eyebrow: "Featured category",
    title: "HA Fillers",
    subtitle: "Premium hyaluronic acid · 90+ SKUs",
    image: "https://images.pexels.com/photos/5922101/pexels-photo-5922101.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=700&w=1000",
    category: "ha-filler",
  },
  {
    eyebrow: "Best sellers",
    title: "Korean Botox",
    subtitle: "Botulax · Nabota · Meditoxin",
    image: "https://images.pexels.com/photos/9227787/pexels-photo-9227787.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=700&w=1000",
    category: "botox",
  },
  {
    eyebrow: "Now in stock",
    title: "Exosome Boosters",
    subtitle: "Next-gen regenerative therapy",
    image: "https://images.pexels.com/photos/7722842/pexels-photo-7722842.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=700&w=1000",
    category: "exosome",
  },
];
